'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import withCommonFieldMap from 'DesignEditorsUI/components/shared/hoc/withCommonFieldMap';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import Small from 'UIComponents/elements/Small';
import EditorTypes from 'ContentUtils/constants/EditorTypes';
import { DEFAULT, PLACEHOLDER } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import withDebouncedInput from 'DesignEditorsUI/components/shared/inputs/withDebouncedInput';
const DebouncedUITextInput = withDebouncedInput(UITextInput);

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class GenericContentOptions extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onFieldChange = value => {
      this.props.editField({
        [DEFAULT]: value
      });
    };

    this.onPlaceholderChange = ({
      target: {
        value
      }
    }) => {
      this.props.editField({
        [PLACEHOLDER]: value
      });
    };
  }

  renderPlaceholderLabel() {
    return /*#__PURE__*/_jsxs(UIFlex, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "m-right-1",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('selectFields.placeholder.label')
        })
      }), /*#__PURE__*/_jsx(UIHelpIcon, {
        title: /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('selectFields.placeholder.tooltip')
          })
        }),
        color: BATTLESHIP,
        tooltipPlacement: "top"
      })]
    });
  }

  render() {
    const {
      field,
      componentsByType,
      formControlProps,
      inputProps,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(ToolFieldset, {
      children: [/*#__PURE__*/_jsx(ToolFormControl, Object.assign({
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`defaultLabels.${field.type}`)
        })
      }, formControlProps, {
        children: /*#__PURE__*/_jsx(SidebarInput, Object.assign({
          onFieldChange: this.onFieldChange,
          value: field[DEFAULT],
          required: false,
          componentsByType: componentsByType,
          editor: EditorTypes.DESIGN_MANAGER,
          type: field.type,
          inputComponent: componentsByType[field.type],
          readOnly: readOnly,
          tooltipPlacement: "top left",
          placeholder: field[PLACEHOLDER]
        }, inputProps))
      })), /*#__PURE__*/_jsx(ToolFormControl, {
        label: this.renderPlaceholderLabel(),
        children: /*#__PURE__*/_jsx(DebouncedUITextInput, {
          "data-test-id": "module-field-placeholder-input",
          onChange: this.onPlaceholderChange,
          value: field[PLACEHOLDER] || '',
          disabled: readOnly
        })
      })]
    });
  }

}

GenericContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  componentsByType: PropTypes.object.isRequired,
  inputProps: PropTypes.object.isRequired,
  formControlProps: PropTypes.object.isRequired,
  readOnly: PropTypes.bool
};
GenericContentOptions.defaultProps = {
  inputProps: {},
  formControlProps: {}
};
export default withCommonFieldMap(GenericContentOptions);